import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorTradingBot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M12.75 4.291a1.636 1.636 0 1 0-1.5 0v4.073h1.5V4.29Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M2.25 9.864a2.25 2.25 0 0 1 2.25-2.25h15a2.25 2.25 0 0 1 2.25 2.25v10.09a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V9.864Zm2.25-.75a.75.75 0 0 0-.75.75v10.09c0 .415.336.75.75.75h15a.75.75 0 0 0 .75-.75V9.864a.75.75 0 0 0-.75-.75h-15Z"
    />
    <path
      fill="#F7A600"
      d="M10.364 13.273a.818.818 0 1 1-1.637 0 .818.818 0 0 1 1.637 0Zm4.909 0a.818.818 0 1 1-1.637 0 .818.818 0 0 1 1.637 0Zm-5.728 3.34a.75.75 0 0 0 0 1.5h4.91a.75.75 0 0 0 0-1.5h-4.91Z"
    />
  </svg>
);
export default SvgTwoColorTradingBot;
